import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14.53 8.88 12 2l-1.17 3.17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Navigation2Off";
const Navigation2Off = memo(themed(Icon));
export {
  Navigation2Off
};
//# sourceMappingURL=navigation-2-off.js.map
